import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconThread = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 11.6631C3.80253 11.9224 3.50007 12.4036 3.5 12.958V20.458H14C14.8284 20.458 15.4999 19.7863 15.5 18.958V17.7578C15.5 17.7553 15.5009 17.7525 15.501 17.75H16.999C16.9991 17.7525 17 17.7553 17 17.7578V18.958C16.9999 20.6148 15.6568 21.958 14 21.958H2V12.958C2.00009 11.5949 2.90927 10.4441 4.1543 10.0791C4.18681 10.0696 4.21915 10.0678 4.25 10.0703V11.6631Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 8.5C10.3023 8.5 10.75 8.94772 10.75 9.5C10.75 10.0523 10.3023 10.5 9.75 10.5C9.19772 10.5 8.75 10.0523 8.75 9.5C8.75 8.94772 9.19772 8.5 9.75 8.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 8.5C14.0523 8.5 14.5 8.94772 14.5 9.5C14.5 10.0523 14.0523 10.5 13.5 10.5C12.9477 10.5 12.5 10.0523 12.5 9.5C12.5 8.94772 12.9477 8.5 13.5 8.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.25 8.5C17.8023 8.5 18.25 8.94772 18.25 9.5C18.25 10.0523 17.8023 10.5 17.25 10.5C16.6977 10.5 16.25 10.0523 16.25 9.5C16.25 8.94772 16.6977 8.5 17.25 8.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M18 2C20.2091 2 22 3.79086 22 6V17H9L8.79395 16.9951C6.7488 16.8913 5.10865 15.2512 5.00488 13.2061L5 13V6C5 3.79086 6.79086 2 9 2H18ZM9 3.5C7.61929 3.5 6.5 4.61929 6.5 6V13C6.5 14.3807 7.61929 15.5 9 15.5H20.5V6C20.5 4.61929 19.3807 3.5 18 3.5H9Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconThread as ReactComponent };
